import React, { Component } from 'react';
import { GoogleMap, Marker, Polygon, InfoWindow } from '@react-google-maps/api';
import FormattedAddress from 'components/FormattedAddress';
import _ from 'lodash';

export default class Maps extends Component {
	constructor(props) {
		super(props);
		this.state = {
			markers: []
		};
		this.mapRef;
		this.markerRefs = [];
		this.layers = [];
	}

	componentDidMount() {
		this.setState({ markers: this.getMarkers() });
	}

	componentDidUpdate() {
		if (!_.isEqualWith(this.state.markers, this.getMarkers())) this.setState({ markers: this.getMarkers() });
	}

	getMarkerInfoState(id) {
		const marker = _.find(this.state.markers, { id });
		if (marker) return marker.showInfo;
		if (this.props.showInfoDefault) return true;
		return false;
	}

	getMarkers() {
		return this.props.data.map(report => {
			// const type = _.find(this.props.types, { id: report.type.id });
			// let statusFolder = 'marker-orange';
			// if (report.status === 7) statusFolder = 'marker-green';
			return {
				id: report.reportId,
				position: report.latlng,
				address: report.address,
				showInfo: this.getMarkerInfoState(report.reportId),
				status: report.status,
				type: report.type.id,
				// icon: `assets/images/types/${statusFolder}/${type ? type.icon : 'sonstiges'}.png`
				icon: `https://www.meldooplus.de/api/v2/images/typemarker/${report.type.id}/${
					report.status === 7 ? 'green' : report.status === 8 || report.status === 3 ? 'red' : 'orange'
				}`
			};
		});
	}

	handleMarkerClick = targetMarkerId => {
		this.setState({
			markers: this.state.markers.map(marker => {
				if (marker.id === targetMarkerId) {
					return {
						...marker,
						showInfo: true
					};
				}
				return marker;
			})
		});
		if (this.props.onMarkerClick) this.props.onMarkerClick(targetMarkerId);
	};

	handleMarkerClose = targetMarkerId => {
		this.setState({
			markers: this.state.markers.map(marker => {
				if (marker.id === targetMarkerId) {
					return {
						...marker,
						showInfo: false
					};
				}
				return marker;
			})
		});
	};

	panTo = latlng => {
		this.mapRef.panTo(latlng);
	};

	getTileUrl = (props, map) => ({ x, y }, zoom) => {
		const tileSizeInPoints = 256 / Math.pow(2, zoom);
		const sw = map.getProjection().fromPointToLatLng(new google.maps.Point(x * tileSizeInPoints, y * tileSizeInPoints + tileSizeInPoints));
		const ne = map.getProjection().fromPointToLatLng(new google.maps.Point(x * tileSizeInPoints + tileSizeInPoints, y * tileSizeInPoints));

		const bbox = `${sw.lat()},${sw.lng()},${ne.lat()},${ne.lng()}`;

		const url = `${props.baseUrl}version=1.3.0&request=GetMap&Layers=${
			props.layers
		}&CRS=EPSG:4326&BBOX=${bbox}&WIDTH=255&HEIGHT=255&FORMAT=image/png&TRANSPARENT=true`;
		return url;
	};

	render() {
		const polygons = this.props.polygons ? this.props.polygons.map(polygon => polygon.paths) : [];

		// Ganze Google Maps als Polygon markieren um dann die Polygone auszuschneiden
		const world = [
			[
				// Uhrzeigersinn
				// { lat: 90, lng: 0 },
				// { lat: 90, lng: 180 },
				// { lat: -90, lng: 180 },
				// { lat: -90, lng: 0 },
				// { lat: -90, lng: -180 },
				// { lat: 0, lng: -180 },
				// { lat: 90, lng: -180 },
				// { lat: 90, lng: 0 }

				// gegen Uhrzeigersinn
				{ lat: 90, lng: 0 },
				{ lat: 90, lng: -180 },
				{ lat: 0, lng: -180 },
				{ lat: -90, lng: -180 },
				{ lat: -90, lng: 0 },
				{ lat: -90, lng: 180 },
				{ lat: 90, lng: 180 },
				{ lat: 90, lng: 0 }
			]
		];
		// Einfügen der Polygone in die Welt als Loch (Uhrzeigersinn)
		for (var i = 0, len = polygons.length; i < len; i++) {
			for (var x = 0, len2 = polygons[i].length; x < len2; x++) {
				world.push(polygons[i][x]);
			}
		}

		if (this.props.panTo) {
			this.panTo(this.props.panTo);
		}

		return (
			<div className={`embed-responsive embed-responsive-${this.props.dimensions || '1by1'}`}>
				<div className="embed-responsive-item">
					<GoogleMap
						zoom={this.props.zoom || 15}
						center={
							this.props.center && this.props.center.lat && this.props.center.lng
								? this.props.center
								: {
										lat: 51.165691,
										lng: 10.451526
								  }
						}
						mapContainerStyle={{
							height: '100%',
							width: '100%'
						}}
						onLoad={map => {
							this.mapRef = map;
							if (this.props.layers) {
								this.props.layers.forEach((props, index) => {
									const layer = new window.google.maps.ImageMapType({
										getTileUrl: (tile, zoom) => this.getTileUrl(props, map)(tile, zoom),
										tileSize: new window.google.maps.Size(256, 256),
										minZoom: 14,
										maxZoom: 24,
										opacity: 0,
										isPng: true
									});

									this.layers[index] = layer;
									map.overlayMapTypes.setAt(index, layer);
								});

								const controlDiv = document.createElement('div');
								controlDiv.style.marginRight = '10px';
								// Create the control.

								const controlButton = document.createElement('div');

								// Set CSS for the control.
								controlButton.style.backgroundColor = '#fff';
								controlButton.style.border = '2px solid #fff';
								controlButton.style.borderRadius = '3px';
								controlButton.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
								controlButton.style.color = 'rgb(25,25,25)';
								controlButton.style.fontFamily = 'Roboto,Arial,sans-serif';
								controlButton.style.fontSize = '16px';
								controlButton.style.lineHeight = '38px';
								controlButton.style.margin = '8px 0 22px';
								controlButton.style.padding = '0 5px';
								controlButton.style.textAlign = 'left';

								const checkbox = document.createElement('input');
								checkbox.type = 'checkbox';
								checkbox.id = 'showLayerSelection';

								checkbox.addEventListener('change', ev => {
									const elements = document.getElementsByClassName('customControlCheckBox');
									for (var i = 0; i < elements.length; i++) {
										elements[i].style.display = ev.target.checked ? 'flex' : 'none';
									}
								});

								const label = document.createElement('label');
								label.htmlFor = 'showLayerSelection';
								label.style.paddingLeft = '5px';
								label.appendChild(document.createTextNode('Ebenenauswahl anzeigen'));
								const inputContainer = document.createElement('div');

								inputContainer.style.display = 'flex';

								inputContainer.appendChild(checkbox);
								inputContainer.appendChild(label);
								controlButton.appendChild(inputContainer);

								this.layers.forEach((l, i) => {
									const checkbox = document.createElement('input');
									checkbox.type = 'checkbox';
									checkbox.id = `layerCheck_${i}`;

									checkbox.addEventListener('change', ev => {
										l.setOpacity(ev.target.checked ? 1 : 0);
									});

									const label = document.createElement('label');
									label.htmlFor = `layerCheck_${i}`;
									label.style.paddingLeft = '5px';
									label.appendChild(document.createTextNode(this.props.layers[i].title));
									const inputContainer = document.createElement('div');

									inputContainer.style.display = 'none';
									inputContainer.className = 'customControlCheckBox';

									inputContainer.appendChild(checkbox);
									inputContainer.appendChild(label);
									controlButton.appendChild(inputContainer);
								});

								controlDiv.appendChild(controlButton);
								map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);
							}
						}}
						options={{
							fullscreenControl: false,
							mapTypeControl: true,
							panControlOptions: false,
							rotateControlOptions: false,
							zoomControl: true,
							streetViewControl: false
						}}
						onClick={({ latLng }) =>
							this.mapRef && this.props.onClick ? this.props.onClick({ lat: latLng.lat(), lng: latLng.lng() }) : null
						}
						onZoomChanged={() => (this.mapRef && this.props.onZoomChanged ? this.props.onZoomChanged(this.mapRef.getZoom()) : null)}
						onCenterChanged={() =>
							this.mapRef && this.props.onCenterChanged
								? this.props.onCenterChanged({ lat: this.mapRef.getCenter().lat(), lng: this.mapRef.getCenter().lng() })
								: null
						}
					>
						{this.state.markers.map(
							(marker, index) =>
								marker.position.lat &&
								marker.position.lng && (
									<Marker
										defaultIcon="assets/images/types/marker-orange/sonstiges.png"
										icon={{
											url: marker.icon,
											scaledSize: { width: 43, height: 51 }
										}}
										key={index}
										position={marker.position}
										onClick={() => this.handleMarkerClick(marker.id)}
										opacity={this.props.markerOpacity || 1}
										onLoad={markerRef => (this.markerRefs[index] = markerRef)}
										onUnmount={() => (this.markerRefs[index] = undefined)}
									>
										{marker.showInfo && this.props.info && this.markerRefs[index] && (
											<InfoWindow onCloseClick={() => this.handleMarkerClose(marker.id)} anchor={this.markerRefs[index]}>
												<FormattedAddress address={marker.address} />
											</InfoWindow>
										)}
									</Marker>
								)
						)}
						{this.props.selectedLocation && this.props.selectedLocation.lat && this.props.selectedLocation.lng && (
							<Marker
								defaultIcon="assets/images/marker.svg"
								position={this.props.selectedLocation}
								draggable
								onDragEnd={({ latLng }) =>
									this.props.onSelectionMarkerDragEnd
										? this.props.onSelectionMarkerDragEnd({ lat: latLng.lat(), lng: latLng.lng() })
										: null
								}
							/>
						)}
						{this.props.limitArea &&
							this.props.polygons &&
							this.props.polygons.map((polygon, index) => (
								<Polygon
									key={index}
									options={{
										fillColor: this.props.mapsFillColor || '#000000',
										fillOpacity: '0.1',
										strokeColor: this.props.mapsStrokeColor || '#000000',
										strokeOpacit: '0.8',
										strokeWeight: 2
									}}
									paths={world}
								/>
							))}
					</GoogleMap>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./containers/Maps.js